import UtilityDrawerBody from 'components/drawers/utility-drawer/utility-drawer-body/utility-drawer-body.component';
import UtilityDrawer from 'components/drawers/utility-drawer/utility-drawer.component';
import { useTranslation } from 'react-i18next';
import MenusFullDetailsButton from './menus-full-details-button/menus-full-details-button.component';
import MenusLocationsList from './menus-locations-list/menus-locations-list.component';
import MenusDisplayContent from './menus-display-content/menus-display-content.component';
import MenusInfoCard from '../menus-info-card/menus-info-card.component';

const MenusDetailsDrawer = ({ open, close, drawerData }) => {
  const { t } = useTranslation();
  const isImported: boolean = !!drawerData?.row?.externalId;

  return (
    <UtilityDrawer
      open={open}
      onClose={close}
      isLoading={false}
      data-testid="MenusDetails.Drawer"
      title={t('drawer.menusDetailsDrawer.title')}
    >
      <UtilityDrawerBody>
        <MenusFullDetailsButton
          close={close}
          catalogId={drawerData?.row?.catalogId}
        />
        <MenusInfoCard data={drawerData?.row} isImported={isImported} />
        {drawerData?.row?.storeInfos?.length > 0 && (
          <MenusLocationsList stores={drawerData?.row?.storeInfos} />
        )}
        <MenusDisplayContent displayInfos={drawerData?.row?.displayInfo} />
      </UtilityDrawerBody>
    </UtilityDrawer>
  );
};

export default MenusDetailsDrawer;
